import { Component, Inject, Optional, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../../shared/services/language.service';
import { TenantsService, TenantDto } from '../../shared/services/tenants.service';

@Component({
  standalone: false,
  selector: 'app-manage-users-dialog',
  templateUrl: './manage-users-dialog.component.html',
  styleUrls: ['./manage-users-dialog.component.css']
})
export class ManageUsersDialogComponent implements OnInit {

  variables: any;
  local_data: any;
  invalidInput = false;
  errorMessage = '';
  formGroup1: any;
  formEditUser: any;
  formAddUser: any;
  roles: any = [];
  isAddUser = false;
  /** True only for super-admins who may pick any organization. */
  canAssignUserTenant = false;
  tenants: TenantDto[] = [];

  constructor(
    public dialogRef: MatDialogRef<ManageUsersDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private languageService: LanguageService,
    private tenantsService: TenantsService
  ) {
    this.local_data = data != null ? { ...data } : {};
  }

  ngOnInit(): void {
    // Add payload has no id; edit payload always includes id. Do not use `email` — both flows include it.
    this.isAddUser = !this.local_data?.element?.id;
    this.canAssignUserTenant = !!this.local_data?.canAssignUserTenant;

    if (!this.isAddUser && !this.local_data?.element) {
      this.dialogRef.close();
      return;
    }

    if (this.canAssignUserTenant) {
      this.tenantsService.list(true).subscribe({
        next: (t) => this.tenants = t ?? [],
        error: () => { this.tenants = []; }
      });
    } else if (this.isAddUser && this.local_data.fixedTenantId) {
      const id = this.local_data.fixedTenantId as string;
      const name = (this.local_data.fixedTenantName as string) || id;
      this.tenants = [{ id, name, active: true }];
    }

    if (this.isAddUser) {
      const fixedId = (this.local_data.fixedTenantId as string) || '';
      const tenantDisabled = !this.canAssignUserTenant && !!fixedId;
      this.formAddUser = this.formBuilder.group({
        addNameCtrl: ['', Validators.required],
        addLastNameCtrl: ['', Validators.required],
        addEmailCtrl: ['', [Validators.required, Validators.email]],
        tenantIdCtrl: [
          { value: fixedId, disabled: tenantDisabled },
          ...(this.canAssignUserTenant ? [Validators.required] : [])
        ]
      });
    } else {
      const controls: Record<string, unknown> = {
        nameCtrl: [this.local_data.element.name, Validators.required],
        lastNameCtrl: [this.local_data.element.lastName, Validators.required],
        emailCtrl: [{ value: this.local_data.element.email ?? '', disabled: true }],
        roleCtrl: [this.local_data.element.role, Validators.required]
      };
      if (this.canAssignUserTenant) {
        controls['tenantIdCtrl'] = [this.local_data.element.tenantId ?? '', Validators.required];
      }
      this.formEditUser = this.formBuilder.group(controls);
    }

    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
      this.roles = [
        { name: vars?.superAdmin, code: 'SUPER-ADMIN' },
        { name: vars?.admin, code: 'ADMIN' },
        { name: vars?.normalUser, code: 'USER' },
        { name: vars?.architect, code: 'ARCHITECT' },
        { name: vars?.estimationOffice, code: 'ESTIMATION-OFFICE' }
      ];
    });
  }

  doAction(): void {
    if (this.isAddUser) {
      if (this.formAddUser.invalid) {
        this.formAddUser.markAllAsTouched();
        return;
      }
      const formGroup = this.formAddUser.getRawValue();
      this.dialogRef.close({ data: formGroup });
      return;
    }

    const formGroup = this.formEditUser.getRawValue();

    if (!formGroup.roleCtrl) {
      this.invalidInput = true;
      this.errorMessage = this.variables?.errorRoleEmpty ?? '';
      return;
    }
    this.invalidInput = false;

    if (this.formEditUser.invalid) {
      this.formEditUser.markAllAsTouched();
      return;
    }

    this.dialogRef.close({ data: formGroup });
  }
}
